import {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/modals/email_confirmation';
import {EmailConfirmation} from '../../../reducers/modals/actions';

import Unconfirmed from './unconfirmed';
import Confirmation from './confirmation';

export default () => {
    const {stage, data, user} = useSelector(Selector),
          dispatch = useDispatch();
    
    useEffect(() => {
        if(stage !== user.email.status)
            dispatch(EmailConfirmation.stage(user.email.status));
    }, [stage]);

    console.log(user);

    return (
        <div className="modal auth animate__animated animate__fadeInUp animate__faster">
            {stage === 'unconfirmed' && <Unconfirmed data={data} user={user} />}
            {stage === 'confirmation' && <Confirmation data={data} user={user} />}
        </div>
    )
}